/**
 * form.js
 * ✅ Three separate scripts:
 * 1) REGISTRATION page form (forms-root-824453)  -> keeps your special behavior (move disclaimer, Montserrat styles, etc.)
 * 2) OTHER forms (2 possible container IDs OR forms-root-823860) -> uses your "simple" layout CSS
 * 3) CUSTOM form (forms-root-864885) -> modifies padding for _formFieldset_cit2d_82
 *
 * Paste this whole file.
 */

/* =========================================================
   1) REGISTRATION FORM (forms-root-824453) — SPECIAL VERSION
   - Targets ONLY data-forms-id="forms-root-824453"
   - Moves disclaimer inside form before submit button
   - Applies your registration-specific CSS
========================================================= */
(function () {
  const formAttr = "forms-root-824453";

  // Moves any <output> siblings into their preceding _formFieldContainer div
  function moveErrorsIntoFields(root) {
    const form = root.querySelector("form");
    if (!form) return;
    form.querySelectorAll("output._formError_1mxsl_21").forEach((output) => {
      const prev = output.previousElementSibling;
      if (prev && prev.classList.contains("_formFieldContainer_1mxsl_5")) {
        prev.appendChild(output);
      }
    });
  }

  const observer = new MutationObserver(() => {
    const container = document.querySelector(`div[data-forms-id="${formAttr}"]`);
    if (!container) return;

    const shadowHost = container.querySelector("#app-embed");
    const root = shadowHost?.shadowRoot;
    if (!root) return;

    // Prevent re-applying
    if (shadowHost.dataset.shadowStyledRegistration === "1") return;
    shadowHost.dataset.shadowStyledRegistration = "1";

    // MOVE DISCLAIMER inside form before submit
    const form = root.querySelector("form");
    const submitBtn = root.querySelector('button[type="submit"]');
    const disclaimer = root.querySelector("._formDisclaimer_cit2d_38");
    if (form && submitBtn && disclaimer) {
      form.insertBefore(disclaimer, submitBtn);
    }

    // Watch form for dynamically injected <output> error elements and move them inside their field div
    const formErrorObserver = new MutationObserver(() => {
      moveErrorsIntoFields(root);
    });
    if (form) {
      formErrorObserver.observe(form, { childList: true, subtree: true });
    }

    const sheet = new CSSStyleSheet();

    // MOBILE RULES (Responsive)
    sheet.insertRule(`
      @media (max-width: 768px) {
        ._formSubmitButton_cit2d_96 { 
          width: 100% !important;
          padding: 12px 24px !important;
          font-size: 14px !important;
          height: 28px !important;
        }
        ._formSubmitButton_cit2d_96::after { 
          width: 8px !important;
          height: 12px !important;
        }
        input, label { 
          font-size: 16px !important;
          line-height: 13px !important;
          height: 11px !important;
        }
        ._formFieldset_cit2d_82 > div._formFieldContainer_1mxsl_5:nth-child(1),
        ._formFieldset_cit2d_82 > div._formFieldContainer_1mxsl_5:nth-child(2) {
          flex: 1 1 100% !important;
          width: 100% !important;
        }
      }
    `);

    // FORM LAYOUT
    sheet.insertRule(`
      form { 
        background: white;
        color: black;
        position: relative;
        display: flex !important;
        flex-direction: row !important;
        flex-wrap: wrap !important;
        gap: 8px !important;
      }
    `);

    sheet.insertRule(`
      ._gridItemContent_1q1d2_257 { 
        padding: 0 !important;
      }
    `);
    sheet.insertRule(`
  ._formFieldContainer_1mxsl_5 {
    position: relative !important;
  }
`);

    // FIRST & LAST NAME (50/50 split)
    sheet.insertRule(`
      ._formFieldset_cit2d_82 > div._formFieldContainer_1mxsl_5:nth-of-type(1),
      ._formFieldset_cit2d_82 > div._formFieldContainer_1mxsl_5:nth-of-type(2) { 
        display: flex !important;
        flex-direction: column-reverse !important;
        align-items: flex-start !important;
        width: calc(50% - 9px) !important;
        gap: 12px !important;
        flex: 1 1 calc(50% - 10px) !important;
      }

    `);

    sheet.insertRule(`
      ._formFieldset_cit2d_82 > div._formFieldContainer_1mxsl_5._withError_1mxsl_17:nth-of-type(1),
      ._formFieldset_cit2d_82 > div._formFieldContainer_1mxsl_5._withError_1mxsl_17:nth-of-type(2) { 
        flex: 0 0 100% !important;
      }
    `);

    sheet.insertRule(`
      ._formPhoneInputContainer_piv1u_6 > ._formError_1mxsl_21 {
        position: absolute;
        bottom: -20px;
      }
    `);

    // EMAIL (Full width)
    sheet.insertRule(`
      ._formFieldset_cit2d_82 > div._formFieldContainer_1mxsl_5:nth-of-type(3) { 
        flex: 1 1 100% !important;
        width: 100% !important;
        display: flex !important;
        flex-direction: column-reverse !important;
        align-items: flex-start !important;
        gap: 12px !important;
        margin-top: 10px !important;
      }
    `);

    // PHONE INPUT CONTAINER
    sheet.insertRule(`
      ._formPhoneInputContainer_piv1u_6 { 
        width: 100% !important;
        display: flex !important;
        align-items: flex-end !important;
        gap: 12px !important;
        margin-top: 10px !important;
      }
    `);

    sheet.insertRule(`
      ._formPhoneInputContainer_piv1u_6 > ._formFieldContainer_1mxsl_5 { 
        flex-direction: column-reverse !important;
        gap: 12px !important;
        width: calc(100% - 80px) !important;
        display: flex !important;
      }
    `);

    sheet.insertRule(`
      label#label-phone_number { 
        margin-left: -92px !important;
        white-space: nowrap !important;
      }
    `);

    // DISCLAIMER STYLING (Now inside the form)
    sheet.insertRule(`
      ._formDisclaimer_cit2d_38 { 
        flex: 1 1 100% !important;
        padding: 4px 0 20px !important;
        color: #696969 !important;
        font-size: 14px !important;
        text-align: left !important;
        font-family: Montserrat !important;
        line-height: 20px !important;
        letter-spacing: normal;
      }
    `);

    sheet.insertRule(`
      ._formDisclaimer_cit2d_38 a { 
        color: #783374 !important;
      }
    `);

    // SUBMIT BUTTON
    sheet.insertRule(`
      ._formSubmitButton_cit2d_96 { 
        padding: 14px 24px !important;
        justify-content: center !important;
        align-items: center !important;
        gap: 8px !important;
        border-radius: 40px !important;
        background: var(--Main-Color, #783374) !important;
        box-shadow: 0 -2px 18px 0 #562154 inset, 0 0 0 2px #91318D inset, 0 0 0 2px rgba(145, 49, 141, 0.60) !important;
        font-family: Montserrat, sans-serif !important;
        font-size: 18px !important;
        position: relative !important;
        cursor: pointer !important;
      }
    `);

    sheet.insertRule(`
      ._formSubmitButton_cit2d_96::after { 
        content: "" !important;
        width: 8px !important;
        height: 14px !important;
        display: inline-block;
        vertical-align: middle;
        background-color: white !important;
        -webkit-mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='9' height='16' viewBox='0 0 9 16' fill='none'%3E%3Cpath d='M-0.000190197 14L6.17498 7.82483L-0.000190197 1.64967L1.64948 0L7.82464 6.17517C8.26208 6.61273 8.50781 7.20612 8.50781 7.82483C8.50781 8.44355 8.26208 9.03694 7.82464 9.4745L1.64948 15.6497L-0.000190197 14Z' fill='black'/%3E%3C/svg%3E") !important;
        mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='9' height='16' viewBox='0 0 9 16' fill='none'%3E%3Cpath d='M-0.000190197 14L6.17498 7.82483L-0.000190197 1.64967L1.64948 0L7.82464 6.17517C8.26208 6.61273 8.50781 7.20612 8.50781 7.82483C8.50781 8.44355 8.26208 9.03694 7.82464 9.4745L1.64948 15.6497L-0.000190197 14Z' fill='black'/%3E%3C/svg%3E") !important;
        -webkit-mask-repeat: no-repeat !important;
        mask-repeat: no-repeat !important;
        -webkit-mask-size: contain !important;
        mask-size: contain !important;
      }
    `);

    // GLOBAL INPUTS & LABELS
    sheet.insertRule(`
      label { 
        position: unset !important;
        color: #2B2B2B !important;
        font-family: Montserrat, sans-serif !important;
        font-size: 18px !important;
        transform: none !important;
        height: 16px !important;
      }
    `);

    sheet.insertRule(`
      label::after { 
        content: "*";
        color: #E21C21;
        margin-left: 4px;
        display: inline;
      }
    `);

    sheet.insertRule(`
      input { 
        width: calc(100% - 48px) !important;
        height: 11px !important;
        padding: 18px 24px !important;
        color: #696969 !important;
        font-family: Montserrat, sans-serif !important;
        font-size: 18px !important;
        font-weight: 400 !important;
        line-height: 30px !important;
        letter-spacing: 0% !important;
      }
    `);

    sheet.insertRule(`
      ._selectContainer_12thd_6 { 
        width: 80px !important;
      }
    `);

    // Declare variables at the form level
    sheet.insertRule(`
      form { 
        --form-field-border-radius: 15px;
        --primary-brand-color: #783374;
      }
    `);

    // APPLY
    root.adoptedStyleSheets = [...root.adoptedStyleSheets, sheet];

    observer.disconnect();
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();


/* =========================================================
   2) OTHER FORMS — SIMPLE VERSION (your "master" version)
   - Targets either:
     a) the 2 container IDs you provided, OR
     b) data-forms-id="forms-root-823860"
   - Applies your simpler CSS inside shadow root
========================================================= */
(function () {
  const containerIds = [
    "AWmZIbFlaK2lSNWhRM__forms_inline_TeGLWh",
    "AQzVIbHNyMk8xR2F4b__forms_inline_9YREfV"
  ];
  const otherFormAttr = "forms-root-823860";

  // Moves any <output> siblings into their preceding _formFieldContainer div
  function moveErrorsIntoFields(root) {
    const form = root.querySelector("form");
    if (!form) return;
    form.querySelectorAll("output._formError_1mxsl_21").forEach((output) => {
      const prev = output.previousElementSibling;
      if (prev && prev.classList.contains("_formFieldContainer_1mxsl_5")) {
        prev.appendChild(output);
      }
    });
  }

  const findOtherContainers = () => {
    const byId = containerIds
      .map((id) => document.getElementById(id))
      .filter(Boolean);

    const byAttr = [
      document.querySelector(`div[data-forms-id="${otherFormAttr}"]`)
    ].filter(Boolean);

    return Array.from(new Set([...byId, ...byAttr]));
  };

  const observer = new MutationObserver(() => {
    const containers = findOtherContainers();
    if (!containers.length) return;

    let styledSomething = false;

    containers.forEach((container) => {
      // IMPORTANT: Do not touch registration form here
      if (container.getAttribute("data-forms-id") === "forms-root-824453") return;

      const shadowHost = container.querySelector("#app-embed");
      const root = shadowHost?.shadowRoot;
      if (!root) return;

      if (shadowHost.dataset.shadowStyledOther === "1") return;
      shadowHost.dataset.shadowStyledOther = "1";

      // Watch form for dynamically injected <output> error elements and move them inside their field div
      const form = root.querySelector("form");
      const formErrorObserver = new MutationObserver(() => {
        moveErrorsIntoFields(root);
      });
      if (form) {
        formErrorObserver.observe(form, { childList: true, subtree: true });
      }

      const sheet = new CSSStyleSheet();

      sheet.insertRule(`
        section[data-sizing="form-wrapper"] { 
          max-width: 700px !important;
          margin: 0 auto;
          color: white;
          text-align: center;
          padding: 10px 0;
        }
      `);

      sheet.insertRule(`
        form { 
          background: white;
          color: black;
          padding: 24px;
          position: relative;
        }
      `);

      sheet.insertRule(`
        ._formFieldset_cit2d_82 { 
          display: flex !important;
          flex-wrap: wrap !important;
          gap: 10px !important;
          flex-direction: row !important;
        }
      `);

      sheet.insertRule(`
        form._formFieldset_cit2d_82 > div:first-child {

display: none !important;

}
      `);

      sheet.insertRule(`
        ._formFieldset_cit2d_82 > div:nth-child(2),
        ._formFieldset_cit2d_82 > div:nth-child(3) { 
          flex: 1 1 calc(50% - 10px) !important;
          min-width: 200px !important;
          display: flex;
          flex-direction: column-reverse;
          align-items: flex-start;
        }
      `);

      sheet.insertRule(`
        ._formFieldset_cit2d_82 > div:nth-child(4),
        ._formSubmitButton_cit2d_96 { 
          flex: 1 1 100% !important;
          width: 100% !important;
          display: flex;
          flex-direction: column-reverse;
          align-items: flex-start;
        }
      `);

      sheet.insertRule(`
        ._formFieldContainer_1mxsl_5 {
          width: 100% !important;
             position: relative !important;
        }
      `);

      sheet.insertRule(`
        input {
          width: 98%;
          height: 38px;
        }
      `);

      sheet.insertRule(`
        button {
          border-radius: 3px;
          background: #783374;
          display: flex;
          width: 100% !important;
          height: 41.19px;
          padding: 12px;
          justify-content: center;
          align-items: center !important;
          color: #fff;
          font-family: Questrial;
          font-size: 16px;
        }
      `);

      sheet.insertRule(`
        output {
          position: absolute;
          color: red;
       top: 0;
    right: 0;
        }
      `);

      // Apply (overwrite-only for this form)
      root.adoptedStyleSheets = [sheet];

      styledSomething = true;
    });

    if (styledSomething) observer.disconnect();
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();


/* =========================================================
   3) CUSTOM FORM (forms-root-864885) — PADDING MODIFIER
   - Targets ONLY data-forms-id="forms-root-864885"
   - Modifies ._formFieldset_cit2d_82 padding to 10px 2px
========================================================= */
(function () {
  const formAttr = "forms-root-864885";

  // Moves any <output> siblings into their preceding _formFieldContainer div
  function moveErrorsIntoFields(root) {
    const form = root.querySelector("form");
    if (!form) return;
    form.querySelectorAll("output._formError_1mxsl_21").forEach((output) => {
      const prev = output.previousElementSibling;
      if (prev && prev.classList.contains("_formFieldContainer_1mxsl_5")) {
        prev.appendChild(output);
      }
    });
  }

  const observer = new MutationObserver(() => {
    const container = document.querySelector(`div[data-forms-id="${formAttr}"]`);
    if (!container) return;

    const shadowHost = container.querySelector("#app-embed");
    const root = shadowHost?.shadowRoot;
    if (!root) return;

    // Prevent re-applying
    if (shadowHost.dataset.shadowStyledCustom === "1") return;
    shadowHost.dataset.shadowStyledCustom = "1";

    // Watch form for dynamically injected <output> error elements and move them inside their field div
    const form = root.querySelector("form");
    const formErrorObserver = new MutationObserver(() => {
      moveErrorsIntoFields(root);
    });
    if (form) {
      formErrorObserver.observe(form, { childList: true, subtree: true });
    }

    const sheet = new CSSStyleSheet();

    // MODIFY PADDING for _formFieldset_cit2d_82
    sheet.insertRule(`
      ._formFieldset_cit2d_82 {
        display: flex !important;
        gap: 12px !important;
        flex-direction: column !important;
        padding: 10px 2px !important;
      }
    `);

    sheet.insertRule(`
  ._formFieldContainer_1mxsl_5 {
    position: relative !important;
  }
`);

    // APPLY
    root.adoptedStyleSheets = [...root.adoptedStyleSheets, sheet];

    observer.disconnect();
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();